import { createAPI } from '../../composable/useAPI';

export const useMaterialAPI = () =>{
  const api = createAPI();

  const request = {
    material: {
      get: async (params) => {
        return await api.get('/api/v2/material', { params })
          .then((res) => { return res.data.data})
          .catch (err => {return false})
      },

      post: async (data) => {
        return await api.post('/api/v2/material', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      put: async (data) => {
          return await api.put('/api/v2/material', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      delete: async(params) => {
        const queryString = params.map((seq) => `materialSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/material?${queryString}`)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      }
    },
    materialIn : {
      get: async (params) => {
        return await api.get('/api/v2/material_in', { params })
          .then((res) => { return res.data.data})
          .catch (err => {return false})
      },

      post: async (data) => {
        return await api.post('/api/v2/material_in', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      put: async (data) => {
          return await api.put('/api/v2/material_in', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      delete: async(params) => {
        const queryString = params.map((seq) => `materialInSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/material_in?${queryString}`)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      }
    },
    materialOut : {
      get: async (params) => {
        return await api.get('/api/v2/material_out', { params })
          .then((res) => { return res.data.data})
          .catch (err => {return false})
      },

      post: async (data) => {
        return await api.post('/api/v2/material_out', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      put: async (data) => {
          return await api.put('/api/v2/material_out', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      delete: async(params) => {
        const queryString = params.map((seq) => `materialOutSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/material_out?${queryString}`)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      }
    },
  };

  return {
    ...request
  };
}

// 1       22  7
// 2 1     44  8
// 3 2 1   66  9
// 4 3 2 1 88  10
// 5 4 3 2 88  11
//   5 4 3 66  12
//     5 4 44  01
//       5 22  02
